import { gql } from '@apollo/client';

export const CREATE_TMS_EXCEPTION = gql`
  mutation CreateTmsException($input: CreateTmsExceptionInput!) {
    createTmsException(input: $input) {
      id
      taskId
      taskNumber
      exceptionReasonType
      location
      remark
      exceptionPhotosJson
      exceptionPhotosUrlsJson
      exceptionWarehouseId
      createdAt
      updatedAt
    }
  }
`;

export interface CreateTmsExceptionInput {
  taskId: number;
  exceptionReasonType: number;
  location: string;
  remark?: string | null;
  exceptionPhotosJson: string[];
  exceptionWarehouseId?: number | null;
}

export interface TmsExceptionType {
  id: string;
  taskId: number;
  taskNumber?: string | null;
  exceptionReasonType: number;
  location: string;
  remark?: string | null;
  exceptionPhotosJson: string[];
  exceptionPhotosUrlsJson: string[];
  exceptionWarehouseId?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface CreateTmsExceptionResponse {
  createTmsException: TmsExceptionType;
}


